import { createFileRoute } from '@tanstack/react-router'
import { ResourcesPage } from '@/features/hospitality/pages/ResourcesPage'

export const Route = createFileRoute('/_app/hospitality/resources')({
  component: ResourcesPage,
})
